const INTERVALO_COMPROBACION = 60_000;
const RETRASO_INICIAL = 15_000;
const CLAVE_INTENTO = 'FrontendVersionIntentada';
const CLAVE_AVISO = 'FrontendVersionDisponible';
const CANAL = 'frontend-version';

const rutaDelBundle = (valor) => {
  if (typeof valor !== 'string' || !valor) return null;
  try {
    return new URL(valor, window.location.origin).pathname;
  } catch {
    return null;
  }
};

const bundleCargado = () => {
  const scripts = Array.from(document.scripts);
  const principal = scripts.find((script) => /\/static\/js\/main\.[^/]+\.js$/.test(rutaDelBundle(script.src) || ''));
  return rutaDelBundle(principal?.src);
};

const recargarConVersion = (versionLocal, versionNueva) => {
  if (!versionNueva || versionNueva === versionLocal) {
    sessionStorage.removeItem(CLAVE_INTENTO);
    return;
  }

  let intento = null;
  try { intento = JSON.parse(sessionStorage.getItem(CLAVE_INTENTO)); } catch { /* noop */ }
  if (intento?.version === versionNueva && Date.now() - intento.fecha < 5 * 60_000) return;

  sessionStorage.setItem(CLAVE_INTENTO, JSON.stringify({ version: versionNueva, fecha: Date.now() }));
  const url = new URL(window.location.href);
  url.searchParams.set('__frontend', versionNueva.split('/').pop() || String(Date.now()));
  window.location.replace(url.toString());
};

/**
 * Detecta despliegues nuevos comparando el bundle ejecutado con el manifiesto
 * de CRA. No necesita una versión previa en producción: el propio hash del
 * fichero main identifica de forma inequívoca cada build.
 */
export const iniciarDetectorVersion = () => {
  if (process.env.NODE_ENV !== 'production') return () => {};

  const versionLocal = bundleCargado();
  if (!versionLocal) return () => {};

  let comprobando = false;
  let destruido = false;
  const canal = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CANAL) : null;

  const aplicar = (version) => recargarConVersion(versionLocal, rutaDelBundle(version));

  const comprobar = async () => {
    if (comprobando || destruido || document.visibilityState === 'hidden') return;
    comprobando = true;
    try {
      const respuesta = await fetch(`/asset-manifest.json?t=${Date.now()}`, {
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      const tipo = respuesta.headers.get('content-type') || '';
      if (!respuesta.ok || !tipo.includes('json')) return;
      const manifiesto = await respuesta.json();
      const versionRemota = rutaDelBundle(manifiesto?.files?.['main.js']);
      if (!versionRemota || versionRemota === versionLocal) {
        sessionStorage.removeItem(CLAVE_INTENTO);
        return;
      }

      canal?.postMessage(versionRemota);
      try {
        localStorage.setItem(CLAVE_AVISO, JSON.stringify({ version: versionRemota, fecha: Date.now() }));
        localStorage.removeItem(CLAVE_AVISO);
      } catch { /* BroadcastChannel o el polling de cada pestaña siguen activos. */ }
      aplicar(versionRemota);
    } catch (error) {
      // Un fallo de red o un deploy a medias se reintenta sin interrumpir la app.
    } finally {
      comprobando = false;
    }
  };

  const alVolver = () => { if (document.visibilityState === 'visible') comprobar(); };
  const alAviso = (evento) => {
    if (evento.key !== CLAVE_AVISO || !evento.newValue) return;
    try { aplicar(JSON.parse(evento.newValue).version); } catch { /* noop */ }
  };
  if (canal) canal.onmessage = (evento) => aplicar(evento.data);

  const inicio = window.setTimeout(comprobar, RETRASO_INICIAL);
  const intervalo = window.setInterval(comprobar, INTERVALO_COMPROBACION);
  document.addEventListener('visibilitychange', alVolver);
  window.addEventListener('focus', comprobar);
  window.addEventListener('online', comprobar);
  window.addEventListener('storage', alAviso);

  return () => {
    destruido = true;
    clearTimeout(inicio);
    clearInterval(intervalo);
    canal?.close();
    document.removeEventListener('visibilitychange', alVolver);
    window.removeEventListener('focus', comprobar);
    window.removeEventListener('online', comprobar);
    window.removeEventListener('storage', alAviso);
  };
};
